import {
  GET_TAGS,
  GET_TAGS_FAILED,
  GET_TAGS_SUCCEEDED,
  CREATE_TAG,
  CREATE_TAG_FAILED,
  CREATE_TAG_SUCCEEDED,
  GET_TAG_MAPPINGS,
  GET_TAG_MAPPINGS_FAILED,
  GET_TAG_MAPPINGS_SUCCEEDED,
} from 'Redux/Types/TagTypes'

const formatTagPayload = ({ value, ...tag }) => ({
  ...tag,
  value: { name: value },
})

const INITIAL_STATE = {
  records: [],
  tagMappingsData: [],
  loading: false,
  created: false,
  creating: false,
  newRecord: null,
  recordsFetched: false,
  tagMappingsFetched: false,
}

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_TAGS:
      return {
        ...state,
        loading: true,
        recordsFetched: false,
      }
    case GET_TAGS_FAILED:
      return {
        ...state,
        loading: false,
        recordsFetched: false,
      }
    case GET_TAGS_SUCCEEDED:
      return {
        ...state,
        loading: false,
        records: payload,
        recordsFetched: true,
      }

    case GET_TAG_MAPPINGS:
      return {
        ...state,
        loading: true,
        tagMappingsFetched: false,
      }
    case GET_TAG_MAPPINGS_FAILED:
      return {
        ...state,
        loading: false,
        tagMappingsFetched: false,
      }
    case GET_TAG_MAPPINGS_SUCCEEDED:
      return {
        ...state,
        loading: false,
        tagMappingsData: payload,
        tagMappingsFetched: true,
      }

    case CREATE_TAG:
      return {
        ...state,
        creating: true,
        created: false,
      }
    case CREATE_TAG_FAILED:
      return {
        ...state,
        created: false,
        creating: false,
      }
    case CREATE_TAG_SUCCEEDED:
      return {
        ...state,
        created: true,
        creating: false,
        records: [...state.records, formatTagPayload(payload)],
      }

    default:
      return state
  }
}
